module.exports = __webpack_public_path__ + "images/Youtube.b89dc5cd27e6833b9fe4ed29f4892463.svg";